module.exports = __webpack_public_path__ + "media/src/assets/Images/phone-call-01-8c95066241bbebe7be43b3f299bcc816.svg";